
    import { subscribeToAuth } from "./src/services/auth.js";

    document.addEventListener("DOMContentLoaded", () => {
      subscribeToAuth((user) => {
        const ctaBtns = document.querySelectorAll(".cta-enroll");
        if (user) {
          // Se o usuário estiver logado, redireciona ao painel do aluno
          ctaBtns.forEach(btn => {
            btn.innerText = "Ir para o Painel do Aluno";
            btn.setAttribute("href", "./painel-aluno.html");
          });
        } else {
          // Se o usuário não estiver logado, aponta para a tela de registro/login da home
          ctaBtns.forEach(btn => {
            btn.innerText = "Matricular-se / Começar Agora";
            btn.setAttribute("href", "./index.html?action=register");
          });
        }
      });
    });
  